import _classCallCheck from '../../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import _toConsumableArray from '../../../../../node_modules/@babel/runtime/helpers/toConsumableArray.es.js';
import memoizeOne from '../../../node_modules/memoize-one/dist/memoize-one.esm.es.js';
import React from 'react';
import { Dropdown } from '../../Dropdown/Dropdown.es.js';
import '../../Dropdown/DropdownDialog.es.js';
import { ViewportContext } from '../../ViewportContext/ViewportContext.es.js';
import '../../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import '@mgmresorts/wcl-styled';
import { StyledWrapper, StyledHiddenSelect } from './Select.styles.es.js';
import { SelectList } from './SelectList.es.js';
import { SelectTrigger } from './SelectTrigger.es.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mergeOptionsWithEmptyOptionLabel = function mergeOptionsWithEmptyOptionLabel(options, emptyOptionLabel) {
  return emptyOptionLabel !== undefined ? [{
    key: '',
    value: '',
    label: emptyOptionLabel
  }].concat(_toConsumableArray(options)) : options;
};

function stopImmediatePropagation(e) {
  if (e.nativeEvent) {
    e.nativeEvent.stopImmediatePropagation();
  }
}

var Select = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.apply(this, arguments);
    _this._triggerFocusRef = /*#__PURE__*/React.createRef();
    _this._listRef = /*#__PURE__*/React.createRef();
    _this._mergeOptionsWithEmptyOptionLabelMemoized = memoizeOne(mergeOptionsWithEmptyOptionLabel);
    _this.typingTimeout = undefined;
    _this.state = {
      dropdownOpen: false,
      selectedOptionIndex: -1,
      typedValue: '',
      updateFocus: false
    };

    _this.scrollToTypedOption = function (typedValue) {
      var idx = 0;

      _this.allOptions.find(function (options, i) {
        var caseSafeOptionValue = (options.label || options.value).toLowerCase();
        var isMatch = caseSafeOptionValue.startsWith(typedValue);

        if (isMatch) {
          idx = i;
        }

        return isMatch;
      });

      _this.setState({
        selectedOptionIndex: idx
      });
    };

    _this.finishTyping = function () {
      _this.setState({
        typedValue: ''
      });

      _this.stopUpdatingFocus();
    };

    _this.stopUpdatingFocus = function () {
      _this.setState({
        updateFocus: false
      });
    };

    _this.handleKeyDown = function (e) {
      if (_this.props.disabled) return;
      var _this$state = _this.state,
          typedValue = _this$state.typedValue,
          dropdownOpen = _this$state.dropdownOpen,
          selectedOptionIndex = _this$state.selectedOptionIndex;
      var key = e.key;

      switch (key) {
        case 'Escape':
          {
            if (dropdownOpen) {
              stopImmediatePropagation(e);
              e.preventDefault();

              _this.closeDropdownDialog();
            }

            break;
          }

        case 'Enter':
        case ' ':
        case 'Space':
        case 'Spacebar':
          {
            stopImmediatePropagation(e);
            e.preventDefault();

            if (dropdownOpen) {
              var selectedOption = selectedOptionIndex !== -1 ? _this.allOptions[selectedOptionIndex] : undefined;

              if (selectedOption) {
                _this.selectOption(selectedOption);

                if (!_this.props.multiple) {
                  _this.closeDropdownDialog();
                }
              }
            } else {
              _this.openDropdownDialog();
            }

            break;
          }

        case 'ArrowUp':
          {
            stopImmediatePropagation(e);
            e.preventDefault();

            if (dropdownOpen) {
              _this.setState(function (prevState) {
                return {
                  selectedOptionIndex: (prevState.selectedOptionIndex - 1 + _this.allOptions.length) % _this.allOptions.length
                };
              });
            } else {
              _this.openDropdownDialog();
            }

            break;
          }

        case 'ArrowDown':
          {
            stopImmediatePropagation(e);
            e.preventDefault();

            if (dropdownOpen) {
              _this.setState(function (prevState) {
                return {
                  selectedOptionIndex: (prevState.selectedOptionIndex + 1 + _this.allOptions.length) % _this.allOptions.length
                };
              });
            } else {
              _this.openDropdownDialog();
            }

            break;
          }

        case 'Tab':
          {
            if (dropdownOpen) {
              _this.closeDropdownDialog();
            }

            break;
          }

        default:
          _this.setState({
            typedValue: "".concat(typedValue).concat(key).toLowerCase(),
            updateFocus: true
          });

          break;
      }
    };

    _this.handleNativeSelectChange = function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e.target.value);
      }
    };

    _this.handleTriggerClick = function () {
      _this.toggleDropdownDialog();
    };

    _this.handleSelectListOptionClick = function (option) {
      _this.finishTyping();

      _this.selectOption(option);

      if (!_this.props.multiple) {
        _this.closeDropdownDialog();
      }
    };

    _this.handleDropdownClose = function () {
      _this.finishTyping();

      _this.closeDropdownDialog();
    };

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      var _this2 = this;

      var _this$state2 = this.state,
          dropdownOpen = _this$state2.dropdownOpen,
          typedValue = _this$state2.typedValue,
          updateFocus = _this$state2.updateFocus;

      if (!prevState.dropdownOpen && dropdownOpen) {
        this.focusList();
      }

      if (updateFocus) {
        this.scrollToTypedOption(typedValue);
        this.stopUpdatingFocus();
      }

      if (prevState.typedValue !== typedValue) {
        window.clearTimeout(this.typingTimeout);
        this.typingTimeout = window.setTimeout(function () {
          _this2.finishTyping();
        }, 500);
      }
    }
  }, {
    key: "allOptions",
    get: function get() {
      var _this$props = this.props,
          options = _this$props.options,
          emptyOptionLabel = _this$props.emptyOptionLabel;
      return this._mergeOptionsWithEmptyOptionLabelMemoized(options, emptyOptionLabel);
    }
  }, {
    key: "focusList",
    value: function focusList() {
      if (this._listRef.current) {
        this._listRef.current.focus();
      }
    }
  }, {
    key: "focusTrigger",
    value: function focusTrigger() {
      if (this._triggerFocusRef.current) {
        this._triggerFocusRef.current.focus();
      }
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option) {
      if (this.props.multiple) {
        var currentValue = this.props.value;
        return currentValue.indexOf(option.value) !== -1;
      }

      return this.props.value === option.value;
    }
  }, {
    key: "selectOption",
    value: function selectOption(option) {
      if (this.props.onChange) {
        if (this.props.multiple) {
          var currentValue = this.props.value || [];
          var nextValue = this.isOptionSelected(option) ? currentValue.filter(function (v) {
            return v !== option.value;
          }) : currentValue.concat([option.value]);

          if (this.props.onChange) {
            this.props.onChange(nextValue);
          }
        } else {
          var deselectOnSelectAgain = this.props.deselectOnSelectAgain;

          var _nextValue = deselectOnSelectAgain && this.isOptionSelected(option) ? '' : option.value;

          if (this.props.onChange) {
            this.props.onChange(_nextValue);
          }
        }
      }
    }
  }, {
    key: "openDropdownDialog",
    value: function openDropdownDialog() {
      var _this$props2 = this.props,
          multiple = _this$props2.multiple,
          value = _this$props2.value;
      var firstSelectedOptionIndex = multiple && value.length > 0 ? this.allOptions.findIndex(function (o) {
        return o.value === value[0];
      }) : !multiple && value ? this.allOptions.findIndex(function (o) {
        return o.value === value;
      }) : -1;
      this.setState({
        dropdownOpen: true,
        selectedOptionIndex: firstSelectedOptionIndex
      });
    }
  }, {
    key: "closeDropdownDialog",
    value: function closeDropdownDialog() {
      this.setState({
        dropdownOpen: false
      });
      this.focusTrigger();
    }
  }, {
    key: "toggleDropdownDialog",
    value: function toggleDropdownDialog() {
      if (this.state.dropdownOpen) {
        this.closeDropdownDialog();
      } else {
        this.openDropdownDialog();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          required = _this$props3.required,
          valid = _this$props3.valid,
          error = _this$props3.error,
          disabled = _this$props3.disabled,
          multiple = _this$props3.multiple,
          value = _this$props3.value,
          placeholder = _this$props3.placeholder,
          emptyOptionLabel = _this$props3.emptyOptionLabel,
          label = _this$props3.label,
          ariaLabel = _this$props3.ariaLabel,
          customTrigger = _this$props3.customTrigger,
          className = _this$props3.className,
          maxHeight = _this$props3.maxHeight;
      var dropdownOpen = this.state.dropdownOpen;

      var Trigger = function Trigger() {
        var triggerProps = {
          id: id,
          required: required,
          valid: valid,
          error: error,
          disabled: disabled,
          multiple: multiple,
          value: multiple ? value.join(', ') : value,
          placeholder: placeholder,
          label: label,
          ariaLabel: ariaLabel,
          dropdownOpen: dropdownOpen,
          triggerFocusRef: _this3._triggerFocusRef,
          onClick: _this3.handleTriggerClick,
          onKeyDown: _this3.handleKeyDown
        };

        if (customTrigger) {
          return customTrigger(triggerProps);
        }

        return /*#__PURE__*/React.createElement(SelectTrigger, Object.assign({}, triggerProps));
      };

      var useNativeSelect = !this.context.minMd && !multiple;
      return /*#__PURE__*/React.createElement(StyledWrapper, {
        className: className,
        "data-testid": Select.displayName
      }, /*#__PURE__*/React.createElement(Dropdown, {
        className: className,
        matchMenuMinWidthToTrigger: true,
        maxHeight: maxHeight,
        trigger: Trigger,
        open: dropdownOpen,
        trapFocus: false,
        onClose: this.handleDropdownClose
      }, /*#__PURE__*/React.createElement(SelectList, {
        ref: this._listRef,
        id: "".concat(id, "__list"),
        "aria-labelledby": label ? "".concat(id, "__label") : undefined,
        value: value,
        activeOptionIndex: this.state.selectedOptionIndex,
        multiple: multiple,
        options: this.allOptions,
        onOptionClick: this.handleSelectListOptionClick,
        onKeyDown: this.handleKeyDown,
        "data-testid": "SelectFormList"
      })), /*#__PURE__*/React.createElement(StyledHiddenSelect, {
        enabled: useNativeSelect,
        multiple: multiple,
        disabled: disabled,
        value: !value ? multiple ? [] : '' : value,
        tabIndex: useNativeSelect ? 0 : -1,
        "aria-hidden": !useNativeSelect,
        "aria-labelledby": label ? "".concat(id, "__label") : undefined,
        onChange: this.handleNativeSelectChange
      }, emptyOptionLabel === undefined && /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true,
        hidden: true
      }, placeholder), this.allOptions.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          key: option.key || option.value,
          value: option.value
        }, option.label || option.value);
      })));
    }
  }]);

  return Select;
}(React.PureComponent);
Select.displayName = 'SelectForm';
Select.defaultProps = {
  valid: false,
  disabled: false,
  required: false,
  options: [],
  multiple: false,
  deselectOnSelectAgain: false,
  maxHeight: 500
};
Select.contextType = ViewportContext;

export { Select };
